module.exports = function sizeHeading (size){
    let sizArr= [];
      for (let i=0 ;i<=size.length;i=i+4){
        sizArr.push(size.slice(i,i+4).trim())
      
      }
      return sizArr
    }